import React, { memo } from 'react';
import classNames from 'classnames';
import { TextLink } from '../TextLink';
import { Typography } from '../../foundations/typography';
import styles from './ProductPodTitle.module.scss';
/**
 * @tdr
 */
var ProductPodTitle = memo(function (_a) {
    var _b;
    var linkClassName = _a.linkClassName, linkComponent = _a.linkComponent, linkHref = _a.linkHref, linkRel = _a.linkRel, linkTarget = _a.linkTarget, onClick = _a.onClick, productSize = _a.productSize, productName = _a.productName, _c = _a.truncated, truncated = _c === void 0 ? false : _c;
    if (!linkHref || !productName)
        return null;
    return (React.createElement(TextLink, { className: linkClassName, component: linkComponent, href: linkHref, onClick: onClick, rel: linkRel, size: "large", target: linkTarget, underline: "never" },
        React.createElement(Typography, { className: classNames(styles.productName, (_b = {},
                _b[styles.truncated] = truncated,
                _b)), "data-testid": "product-name", element: "h2", noMargins: true, styleAs: "paragraphHeading" }, productName),
        productSize ? (React.createElement(Typography, { element: "span", noMargins: true, styleAs: "paragraph" }, productSize)) : null));
});
ProductPodTitle.displayName = 'ProductPodTitle';
export default ProductPodTitle;
//# sourceMappingURL=ProductPodTitle.js.map